module.exports = __webpack_public_path__ + "img/layerth.642f4969.png";